import * as React from 'react'
import { pieArcClasses, PieChart, PieChartProps, pieClasses } from '@mui/x-charts/PieChart'
import { styled } from '@mui/material/styles'
import { useDrawingArea } from '@mui/x-charts'

import { maxBy } from 'lodash'
import { Text } from '../text'
import { Box } from '@mui/material'

export const CompletionChart = (props: any) => {
  const { data } = props

  const [highlighted, setHighlighted] = React.useState<number>(data.indexOf(maxBy(data, 'value')))

  const empty = data.every((d) => !d.value)

  const settings = {
    series: [
      {
        id: 'inner',
        innerRadius: 85,
        outerRadius: 120,
        data,
        highlightScope: { fade: 'global', highlight: 'item' },
        valueFormatter: (v, { dataIndex }) => {
          const { users } = data[dataIndex]
          return `${users} User${users === 1 ? '' : 's'}`
        },
      },
    ],
    onHighlightChange: (item) => {
      setHighlighted(item?.dataIndex || data.indexOf(maxBy(data, 'value')))
    },
    height: 300,
    showToolbar: true,
  } satisfies PieChartProps

  return empty ? (
    <Box height="300px" display="flex" justifyContent="center" alignItems="center">
      <Text textAlign="center" variant="titleEmphasized" text="No data available" />
    </Box>
  ) : (
    <PieChart
      {...settings}
      sx={{
        [`.${pieClasses.series}[data-series="outer"] .${pieArcClasses.root}`]: {
          opacity: 0.6,
        },
      }}
    >
      <PieCenterLabel>{data[highlighted].value}%</PieCenterLabel>
      <PieCenterSubtitle>{data[highlighted].centerLabel}</PieCenterSubtitle>
    </PieChart>
  )
}

const StyledText = styled('text')(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: 'middle',
  dominantBaseline: 'central',
  fontSize: 24,
  fontWeight: 700,
  fontFamily: 'Inter',
}))

const StyledSubText = styled('text')(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: 'middle',
  dominantBaseline: 'central',
  fontSize: 16,
  fontWeight: 400,
  fontFamily: 'Inter',
}))

function PieCenterLabel({ children }: { children: React.ReactNode }) {
  const { width, height, left, top } = useDrawingArea()
  return (
    <StyledText x={left + width / 2} y={top + height / 2.2}>
      {children}
    </StyledText>
  )
}

function PieCenterSubtitle({ children }: { children: React.ReactNode }) {
  const { width, height, left, top } = useDrawingArea()
  return (
    <StyledSubText x={left + width / 2} y={top + height / 1.8}>
      {children}
    </StyledSubText>
  )
}
